import { Input } from "./ui/input";
import { MagnifyingGlass, X } from "phosphor-react";

/**
 * Shared FilterInput component for consistent live filtering across all pages.
 * 
 * Props:
 * - value: current filter value
 * - onChange: callback when filter changes
 * - placeholder: optional custom placeholder (default: "Filter...")
 * - testId: data-testid attribute
 * - className: additional CSS classes
 */
export default function FilterInput({ 
  value, 
  onChange, 
  placeholder = "Filter...",
  testId = "filter-input",
  className = ""
}) {
  return (
    <div className={`relative flex-1 max-w-xs ${className}`}>
      <MagnifyingGlass
        size={18}
        className="absolute left-3 top-1/2 -translate-y-1/2 text-zinc-400 pointer-events-none"
      />
      <Input
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="pl-9 pr-8 h-10 border-2 border-zinc-200 focus:border-[#FF6600] focus:ring-[#FF6600]/20"
        data-testid={testId}
      />
      {value && (
        <button
          type="button"
          onClick={() => onChange("")}
          className="absolute right-2 top-1/2 -translate-y-1/2 p-1 text-zinc-400 hover:text-zinc-600 transition-colors"
          aria-label="Clear filter"
          data-testid={`${testId}-clear`}
        >
          <X size={16} />
        </button>
      )}
    </div>
  );
}
